import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import WhiteNavbar from "components/Navbars/WhiteNavbar";
import Footer from "components/Footers/Footer";
import { KVKK_TEXT } from "content/legal/KvkkText";

const Kvkk = () => {
  React.useEffect(() => {
    document.body.classList.add("contact-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;

    return function cleanup() {
      document.body.classList.remove("contact-page");
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);

  // Word metnini satır satır göstermek için
  const lines = KVKK_TEXT.trim().split("\n");

  return (
    <>
      <Helmet>
        <title>KVKK Aydınlatma Metni | Ekşioglu Hukuk</title>
        <meta name="theme-color" content="#000000" />
        <meta
          name="description"
          content="KVKK kapsamında kişisel verilerin işlenmesine ilişkin aydınlatma metni."
          data-rh="true"
        />
        <link rel="canonical" href="https://www.eksiogluhukukofisi.com/kvkk" />
        <meta
          property="og:title"
          content="KVKK Aydınlatma Metni | Ekşioglu Hukuk"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:description"
          content="KVKK Aydınlatma Metni | Ekşioglu Hukuk"
        />
        <meta
          property="og:image"
          content="https://www.eksiogluhukukofisi.com/static/media/eksiogluWhiteLogo.e14b5e9c41e5271d670c.png"
        />
        <meta
          property="og:url"
          content="https://www.eksiogluhukukofisi.com/kvkk"
        />
      </Helmet>

      <div>
        <WhiteNavbar />

        <Container>
          <div className="section">
            <Row>
              <Col className="ml-auto mr-auto text-center" md="12">
                <div className="my-6">
                  <h1
                    className="font-weight-bold font-sans"
                    style={{
                      background: "linear-gradient(135deg, #0F172A, #333333)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      fontSize: "2.2em",
                      marginBottom: "18px",
                    }}
                  >
                    KİŞİSEL VERİLERİN İŞLENMESİ HAKKINDA AYDINLATMA METNİ
                  </h1>
                </div>
              </Col>
            </Row>

            <Row>
              <Col className="ml-auto mr-auto" md="12">
                <Card className="bg-white rounded-lg shadow-lg overflow-hidden font-sans">
                  <CardBody className="p-4">
                    <div
                      style={{
                        whiteSpace: "pre-wrap",
                        lineHeight: 1.75,
                        color: "#0F172A",
                      }}
                    >
                      {lines.map((rawLine, idx) => {
                        const line = (rawLine || "").replace(/\r/g, "");
                        const trimmed = line.trim();

                        if (!trimmed) {
                          return <div key={idx} style={{ height: 10 }} />;
                        }

                        const isNumberedHeading = /^\d+\s*\./.test(trimmed);
                        const isMainHeading =
                          trimmed === "Kişisel Verilerin Korunması";
                        const isHeading = isNumberedHeading || isMainHeading;

                        const isFooterBold =
                          trimmed === "Ekşioğlu Hukuk Danışmanlık Ofisi";

                        const isBullet =
                          trimmed.startsWith("•") ||
                          trimmed.startsWith("-") ||
                          trimmed.startsWith("–") ||
                          trimmed.startsWith("—");

                        const bulletText = isBullet
                          ? trimmed.replace(/^(•|-|–|—)\s*/, "")
                          : "";

                        if (isBullet) {
                          return (
                            <div
                              key={idx}
                              style={{
                                display: "flex",
                                gap: 10,
                                alignItems: "flex-start",
                                marginBottom: 8,
                              }}
                            >
                              <span
                                aria-hidden="true"
                                style={{
                                  width: 18,
                                  lineHeight: "20px",
                                  fontSize: 16,
                                  fontWeight: 900,
                                }}
                              >
                                •
                              </span>

                              <p
                                style={{
                                  margin: 0,
                                  color: "#0f172a",
                                  lineHeight: 1.7,
                                  fontSize: 14,
                                }}
                              >
                                {bulletText}
                              </p>
                            </div>
                          );
                        }

                        const textNode =
                          isHeading || isFooterBold ? (
                            <strong>{trimmed}</strong>
                          ) : (
                            trimmed
                          );

                        return (
                          <p
                            key={idx}
                            style={{
                              marginBottom: isHeading ? 14 : 10,
                              marginTop: isHeading ? 18 : 0,
                              fontSize: isHeading ? 15 : 14,
                              color: isHeading ? "#0f172a" : "#334155",
                              lineHeight: 1.75,
                              fontWeight: isHeading ? 700 : 400,
                            }}
                          >
                            {textNode}
                          </p>
                        );
                      })}
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      </div>

      <Footer />
    </>
  );
};

export default Kvkk;
